export default {
    data() {
        return {
            table: 'city',
            datas: {
                add: {
                },
                order: {
                    myorder: 'asc',
                    id: 'asc'
                }
            }
        };
    },
    created() {

        this._load();
    },
    methods: {

    },
};